var React = require('react');

function TickIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.5","cy":"12.5","r":"12.5","fill":"#2CD19E","key":0}),React.createElement("g",{"clipPath":"url(#clip0_1122_2201)","key":1},React.createElement("path",{"d":"M11.4144 13.9763L15.6334 9.89002C16.0161 9.51941 16.6391 9.51941 17.0218 9.89002C17.4044 10.2606 17.4044 10.8641 17.0218 11.2347L12.1062 15.9909C11.7235 16.3615 11.1005 16.3615 10.7178 15.9909L7.98037 13.3396C7.59281 12.9642 7.59281 12.3655 7.98037 11.9949C8.36793 11.6243 8.98606 11.6243 9.36871 11.9949L11.4144 13.9763Z","fill":"white"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_1122_2201"},React.createElement("rect",{"width":"9.61538","height":"6.6568","fill":"white","transform":"translate(7.69141 9.61523)"})))]);
}

TickIcon.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = TickIcon;

TickIcon.default = TickIcon;
